import { render, staticRenderFns } from "./btn-arrow-primary.vue?vue&type=template&id=e058a95e&scoped=true&"
import script from "./btn-arrow-primary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e058a95e",
  null
  
)

export default component.exports